import React__default from 'react';
import { useDispatch } from '@grandvisionhq/state';
import { useSetShippingMethod } from '../../../../hooks/use-set-shipping-method.js';
import { toggleDeliveryAddress } from '../../../actions.js';
import { ShippingMethod } from '../../../../models/step-shipping/shipping-methods.js';

const useShippingMethodSelection = ({ onError , shippingMethodList  })=>{
    const dispatch = useDispatch();
    /**
   *  Error callback for setShippingMethod mutation
   */ const onShippingMethodError = React__default.useCallback(()=>{
        onError && onError();
    }, [
        onError
    ]);
    const { setShippingMethod , setSelectedShippingMethod  } = useSetShippingMethod({
        onError: onShippingMethodError
    });
    /**
   * Shipping method selection handler
   * @augments method: string
   */ const handleChange = React__default.useCallback((method)=>{
        if (!shippingMethodList || shippingMethodList.length < 0) {
            throw new Error('No shipping methods available!');
        }
        const shippingMethod = shippingMethodList.find((item)=>item.key === method
        );
        if (!shippingMethod) {
            console.warn('Partially unsupported shipping method selected, attempting to select it');
        } else {
            if (method !== ShippingMethod.Delivery && method !== ShippingMethod.DeliveryExpress) {
                dispatch(toggleDeliveryAddress({
                    enabled: false
                }));
            }
            setShippingMethod(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.id);
            /**
         *  Update redux after successful update
         *  cart shipping method
         */ setSelectedShippingMethod && setSelectedShippingMethod(method);
        }
    }, [
        shippingMethodList,
        setShippingMethod,
        setSelectedShippingMethod,
        dispatch
    ]);
    return {
        handleOnShippingMethodSelected: handleChange
    };
};

export { useShippingMethodSelection };
//# sourceMappingURL=use-shipping-method-selection.js.map
